import { InvisibleSmartCaptcha } from "@yandex/smart-captcha";

import { inject, observer } from "mobx-react";

import { getWhatId, isCaptchaEnabled, sendMetric } from "../helpers/utils";

const key = "ysc1_i9piyQJtYbburSN71hne9cFhPlgDs8ANioqyUDaLaa61fcc1";
const { VITE_WHAT_ID } = import.meta.env;

import "./style.scss";

const Captcha = inject("mainStore")(
    observer(({ mainStore, onSuccess = () => {}, onChallengeVisible = () => {}, onChallengeHidden = () => {}, onTokenExpired = () => {}, onNetworkError = () => {}, id = "" }) => {
        const captcha = mainStore.getMainStore("captcha");

        const captchaRisMetrika = mainStore.getMainStore("captchaRisMetrika");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        if (!isCaptchaEnabled) return null;

        const handleSuccess = (token) => {
            mainStore.setMainStore("capToken", token);
            mainStore.setMainStore("captcha", false);
            setTimeout(() => onSuccess(), 100);
        };

        const handleChallengeVisible = () => {
            mainStore.setMainStore("capToken", "qwerty");
            sendMetric(`captcha`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: null,
                params3: null,
                params4: null,
                params6: null,
                params7: null,
                params8: what_id,
            });

            if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                window.risMetrika.reachgoal_ch(captchaRisMetrika);
            }
            onChallengeVisible();
        };

        return (
            <div id={id} className="captcha">
                <InvisibleSmartCaptcha
                    sitekey={key}
                    onSuccess={handleSuccess}
                    visible={captcha == id}
                    onChallengeVisible={handleChallengeVisible}
                    onChallengeHidden={onChallengeHidden}
                    onTokenExpired={onTokenExpired}
                    onNetworkError={onNetworkError}
                />
            </div>
        );
    }),
);

export default Captcha;
